import { Amplify } from 'aws-amplify';
import { COGNITO_CONFIG } from './secureCognito';

// const COGNITO_CONFIG = {
//     userPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID || '',
//     userPoolClientId: process.env.REACT_APP_COGNITO_CLIENT_ID || '',
//     region: process.env.REACT_APP_COGNITO_REGION || 'us-east-1',
// };


// Configure Cognito with default user pool (Lapzo Users)
export const configureCognito = () => {
    Amplify.configure({
        Auth: {
            Cognito: {
                userPoolId: COGNITO_CONFIG.userPoolId,
                userPoolClientId: COGNITO_CONFIG.userPoolClientId,
                loginWith: {
                    email: true,
                },
            },
        },
    });
};

// Configure Cognito with client-specific user pool
export const configureCognitoWithUserPool = (userPoolId: string, userPoolClientId?: string | null) => {
    Amplify.configure({
        Auth: {
            Cognito: {
                userPoolId: userPoolId,
                userPoolClientId: userPoolClientId || COGNITO_CONFIG.userPoolClientId,
                loginWith: {
                    email: true,
                },
            },
        },
    });
};
export { COGNITO_CONFIG };
